import moment from 'moment';

// Rows for the bounce, drop and spam report drawers, built from
// getMessageEventInfo the same way as Email.js, Text.js and EmailABversion.js
// (A and B rows together). Under 'all' the Bounce tile counts email and text
// bounces, so its report lists both; under 'email' or 'text' it lists that
// channel's bounces only.

const toRow = contactField => event => ({
  ...event,
  time: moment.unix(event.time).format('MM-DD-YYYY hh:mm A'),
  contact: event[contactField],
});

const withVersionB = (events, field) => [
  ...events[field],
  ...(events.versionB ? events.versionB[field] : []),
];

export const REPORT_TITLES = { bounce: 'Bounce', drop: 'Dropped Emails' };

export const getReportRows = (
  tileKey,
  { emailEvents, textEvents },
  channel
) => {
  if (tileKey === 'bounce') {
    return [
      ...(channel === 'text'
        ? []
        : withVersionB(emailEvents, 'bounceEvents').map(toRow('email'))),
      ...(channel === 'email'
        ? []
        : withVersionB(textEvents, 'bounceEvents').map(toRow('phone'))),
    ];
  }
  if (tileKey === 'drop') {
    return withVersionB(emailEvents, 'droppedEvents').map(toRow('email'));
  }
  return withVersionB(emailEvents, 'spamEvents').map(toRow('email'));
};
